exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-v-6e6ca759] .has-gutter .yxt-checkbox__inner{display:none}.pages-box[data-v-6e6ca759]{text-align:right}\n", ""]);

